import React from 'react'
import Navbar from '../Compponents/Navbar/Navbar'
import { Outlet } from 'react-router-dom'
import Footer from '../Compponents/Footer/Footer'

export default function Layout2() {
  return (
    <div>
        <Navbar/>
        <Outlet/>
        <Footer/>
    </div>
  )
}
